import Typography from '@mui/material/Typography';
import React from 'react';
import {useTranslation} from 'react-i18next';

type PollingStatusTextProps = {
   pollCount: number;
};

const PollingStatusText = ({pollCount}: PollingStatusTextProps) => {
   const {t} = useTranslation();
   if (!pollCount) {
      return null;
   }
   return (
      <Typography variant={'body2'}>
         {t('Key creation can take several minutes. Please wait')}
         {Array.from({length: pollCount}, (el, idx) => (
            <span key={idx}>.</span>
         ))}
      </Typography>
   );
};

export default PollingStatusText;
